import { request } from '@/utils/request';
import type { ApiResponse, WrappedResult } from './types';

const rolesApi = {
  getAll(params: any): ApiResponse<WrappedResult<any>> {
    return request({
      method: 'get',
      url: '/roles',
      params,
    });
  },
  getOne(id: number): ApiResponse<WrappedResult<any>> {
    return request({
      method: 'get',
      url: `/roles/${id}`,
    });
  },
};

export default rolesApi;
